<!-- Header -->
<div class="inbound-email-caption">{{ 'email_activity_Caption' | xsI18n }}</div>

<div class="inbound-email-header">
  <div class="header-received-from">
    <span
      [soti-tooltip]="activity.details?.senderEmail"
      hd-ellipsis-text
      one-time="true"
      no-ellipsis-tooltip="true"
      append-to-body="true"
      >{{
        'email_Received_From_Caption'
          | xsI18n : (activity.details?.sender ? activity.details?.sender : ('anonymous_user_token' | xsI18n))
      }}</span
    >
  </div>
  <div class="header-received-pipe">
    <span class="subtext-gray">|</span>
  </div>
  <div class="header-received-date">
    <span class="activity-updating-time-regular subtext-gray">
      <xs-updating-time [hidespan]="true" [time]="activity.creationDate"></xs-updating-time
    ></span>
  </div>
</div>

<!-- Recipients-->
<!-- <div class="inbound-email-recipients">
  <div *ngIf="recipientsUserInfos?.length > 0" class="to-list">
    <xs-collapsible-user-list
      [userInfoList]="recipientsUserInfos"
      [label]="'email_Sent_To_Caption' | xsI18n"
    ></xs-collapsible-user-list>
  </div>

  <div class="cc-list" *ngIf="recipientsCCUserInfos?.length > 0">
    <xs-collapsible-user-list
      [userInfoList]="recipientsCCUserInfos"
      [label]="'email_Sent_CC_Caption' | xsI18n"
    ></xs-collapsible-user-list>
  </div>
</div> -->

<!-- Body -->
<div class="inbound-email-body">
  <div class="inbound-email-content-wrapper">
    <iframe
      xsightAutoSizeFrame
      scrolling="no"
      [srcdoc]="isExpanded ? emailBody : emailWithoutHistory"
      *ngIf="activity?.details?.isHtml"
      class="inbound-email-content"
    ></iframe>
    <div class="inbound-email-content" *ngIf="!activity?.details?.isHtml">
      {{ isExpanded ? emailBody : emailWithoutHistory }}
    </div>
    <div class="toggle-show-history-button-wrapper" *ngIf="hasMessageHistory">
      <a type="button" class="toggle-show-history-button" (click)="toggleIsExpanded()">
        <div class="show-history-text" *ngIf="!isExpanded">
          {{ 'email_Show_History_Caption' | xsI18n }}<span class="hd-icon hd-icon-doublearrow-down"></span>
        </div>
        <div class="show-history-text-expanded" *ngIf="isExpanded">
          {{ 'email_Hide_History_Caption' | xsI18n }}<span class="hd-icon hd-icon-doublearrow-up"></span>
        </div>
      </a>
    </div>
  </div>
</div>

<!-- Email attachments -->
<xs-email-attachment [attachments]="attachments" [showClose]="false"> </xs-email-attachment>

<!-- Error -->
<div class="email-error" *ngIf="errorMessage">
  <span class="email-error-message">{{ errorMessage }}</span>
</div>
